<div *ngIf="!loading" [innerHTML]="data">

</div>
<novo-loading *ngIf="loading"></novo-loading>
